import CookieConsent from 'react-cookie-consent';
import {Badge} from "@city-sage/aurum-avis-labs-components";

export function CookieBanner() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="I Agree"
      declineButtonText="Decline"
      cookieName="CitySageCookieConsent"
      expires={30}
      contentClasses="!max-h-fit"
      buttonWrapperClasses="!p-0"
      buttonClasses="!bg-primary !text-primary-foreground !hover:bg-primary/90 !py-2 !px-4 !text-sm !rounded-md"
      containerClasses="!flex !flex-col !h-auto !bg-card !text-card-foreground !rounded-lg !shadow-lg !p-4 lg:!p-6 !max-w-[90%] lg:!max-w-2xl !mx-auto !bottom-4 lg:!bottom-8 !left-[5%] lg:!left-[25%] overflow-hidden !z-[60]"
    >
      <div className="flex flex-wrap items-start justify-between mb-4 space-y-2 lg:space-y-0">
        <h2 className="text-lg font-semibold">Cookie Consent</h2>
        <Badge variant="outline" className="text-xs font-bold">
          Alpha
        </Badge>
      </div>
      <p className="mb-2 text-sm leading-relaxed">
        We use cookies to enhance your experience and analyze our traffic. By
        clicking "I Agree," you consent to our use of cookies.
      </p>
      <p className={'text-sm leading-relaxed'}>
        Please note
        that CitySage is currently in <b>alpha</b>, and by using this site, you agree
        to participate in our testing phase.
      </p>
    </CookieConsent>
  );
}
